import React from "react";
import UserDetail from "./UserDetail";
import UserService from "../../../../../services/UserService";
import { labels } from "../../../../../localization/labels";
import { paths } from "../../../../paths";
import TableComponentWithDialog from "../../../page/TableComponentWithDialog";
import PartyRoleService from "../../../../../services/PartyRoleService";
import TableUtils from "../../../../core/Table/TableUtils";
import { activeFilter } from "../../../../../services/FilteringUtils";
import PathUtil from "../../../../../utils/PathUtil";

class UserDetailContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.userService = new UserService();
    this.partyRoleService = new PartyRoleService();

    this.state = {
      ...this.state,
      user: undefined,
      activeFilters: activeFilter,
      disabled: true
    };
  }

  componentDidMount() {
    this.id = this.resolveItemId();
    if (this.id) {
      this.loadUser(this.id);
    } else {
      this.setComponentTitle(labels.user);
    }
  }

  getComponentTitle = () => {
    return this.state.user ? this.state.user.username : undefined;
  };

  loadUser = id => {
    this.prepareCall(
      this.userService.getUserByParty(
        id,
        this.onUserLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onUserLoad = data => {
    this.setState({ user: data });
    this.setComponentTitle(this.state.user.username, true);
    this.loadData(this.state.pageInfo);
  };

  possibleSizesPerPage() {
    return [5, 10, 15];
  }

  onDeleteData = entity => {
    this.prepareCall(
      this.partyRoleService.deleteEntity(
        entity,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemsPath(
      {
        path: paths.USERS,
        partyId: this.state.user.partyId
      },
      {
        path: paths.USERROLES,
        id: row.id
      }
    );

    this.changePath(itemPath, row.name);
  };

  handleAddNew = () => {
    const itemPath = PathUtil.adminItemsPath(
      {
        path: paths.USERS,
        partyId: this.state.user.partyId
      },
      {
        path: paths.USERROLES
      }
    );
    this.changePath(itemPath, labels.userRole);
  };

  selectRow = {
    mode: "checkbox",
    selectColumnStyle: {
      textAlign: "center"
    },
    headerColumnStyle: {
      textAlign: "center"
    }
  };

  loadData = pageInfo => {
    pageInfo = {
      ...pageInfo,
      filters: this.state.activeFilters
    };

    if (this.state.user && this.state.user._links) {
      const url = this.state.user._links.partyRoles.href;

      this.prepareCall(
        this.partyRoleService.getEntitiesWithParams(
          url,
          pageInfo,
          this.sortInfo,
          this.onDataLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      sort: true,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "partyRoleTypeName",
      text: labels.roleType,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  render() {
    return (
      <UserDetail
        {...this.renderProps()}
        user={this.state.user}
        history={this.props.history}
        handleAddNew={this.handleAddNew}
      />
    );
  }
}

export default UserDetailContainer;
